import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotes = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(4 2)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M7,5H5A1,1,0,0,0,4,6V21a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V6a1,1,0,0,0-1-1H17",
					transform: "translate(-4 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M8,16h8",
					transform: "translate(-4 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M10,19h4",
					transform: "translate(-4 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M9,4l.447-.894A2,2,0,0,1,11.236,2h1.528a2,2,0,0,1,1.789,1.106L15,4h1a1,1,0,0,1,1,1V6a1,1,0,0,1-1,1H8A1,1,0,0,1,7,6V5A1,1,0,0,1,8,4Z",
					transform: "translate(-4 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M10.5,11.5h3",
					transform: "translate(-4 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M12,10v3",
					transform: "translate(-4 -2)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgNotes;
